<!-- MyPlan.vue -->
<template>
  <div class="my-plan-container">
    <div class="title-1" style="margin: 12px 0 0 0">{{ planData.title }}</div>
    <div class="plan-grid flex-between">
      <div
        class="plan-item flex-between"
        @click="handleClick(item)"
        v-for="(item, index) in chartData"
        :key="index"
        @click.stop="goDetail(item.path)"
      >
        <div class="plan-content">
          <div class="plan-name">{{ item.name }}</div>
          <div class="plan-count">{{ item.value }}</div>
        </div>
        <div v-show="item.path" class="right-icon flex-center">
          <a-icon type="right" style="font-size: 14px; color: #fff" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyPlan',
  props: {
    planData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    chartData() {
      return this.planData.chartData || []
    },
  },
  methods: {
    handleClick(item) {
      console.log('点击了：', item)
      this.$emit('click', item)
    },
    goDetail(path) {
      this.$router.push(path)
    },
  },
}
</script>

<style scoped lang="less">
.my-plan-container {
  box-sizing: border-box;
  height: 350px;
  padding: 15px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.title-1 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
}

.plan-grid {
  flex-wrap: wrap;
  margin-top: 15px;
  .plan-item {
    width: 48.5%;
    margin-top: 20px;
    padding: 20px;
    border-radius: 10px;
    cursor: pointer;
    background-color: #f8fafc;
    transition: all 0.2s ease;
    &:hover {
      background-color: #eef2f7;
    }
    &.active {
      background-color: #eef2f7;
    }

    .plan-name {
      font-size: 14px;
      color: #666;
      margin-bottom: 12px;
      text-align: center;
    }

    .plan-count {
      font-size: 24px;
      font-weight: bold;
      color: #333;
    }

    .right-icon {
      width: 16px;
      height: 16px;
      background-color: #d7d9d9;
      border-radius: 50%;
    }
  }
}
</style>
